{
  "generations": {
    "headTitle": "Генерации",
    "titlePlatform": "Генерации",
    "titleCompany": "Генерации · {{name}}",
    "companyFallback": "компания",
    "titleProject": "Генерации · {{name}}",
    "refresh": "Обновить",
    "searchPlaceholder": "Поиск…",
    "periodAll": "Все время",
    "period24h": "24 часа",
    "period7d": "7 дней",
    "allCompanies": "Все компании",
    "allProjects": "Все проекты",
    "allUsers": "Все пользователи",
    "activeOnly": "Только активные",
    "jobKind": "Вид работы",
    "jobKindReset": "Все виды",
    "creativeOnly": "Без служебных",
    "creativeOnlyHint": "Скрыть экспорты, дубли проекта, чат агента и сборки — оставить творческие работы",
    "feedCount": "Лента · {{count}}",
    "emptyFilter": "Нет генераций по фильтру",
    "projectLink": "Проект «{{name}}»",
    "shotLink": "{{label}}",
    "shotLinkFallback": "Шот {{id}}",
    "canvasLink": "Холст",
    "mediaLink": "Открыть результат",
    "canvasModalLoadFailed": "Не удалось загрузить генерацию холста",
    "loadingLogs": "Загрузка логов…",
    "logsLoadFailed": "Не удалось загрузить логи",
    "noProviderLogs": "Нет логов провайдера",
    "request": "Запрос",
    "response": "Ответ",
    "payloadNotSaved": "Payload не сохранён",
    "responseNotSaved": "Ответ не сохранён",
    "toggleDetails": "Подробности задачи",
    "stop": "Остановить",
    "stopConfirm": "Остановить генерацию принудительно? Она будет отменена, резерв баланса вернётся. Используйте для зависших задач, которые не завершаются сами.",
    "stopFailed": "Не удалось остановить генерацию"
  },
  "dialogs": {
    "headTitle": "Агенты",
    "titlePlatform": "Агенты",
    "titleCompany": "Агенты · {{name}}",
    "companyFallback": "компания",
    "searchPlaceholder": "Поиск",
    "searchHint": "Поиск диалогов",
    "searchClear": "Очистить поиск",
    "periodAll": "Все время",
    "period24h": "24 часа",
    "period7d": "7 дней",
    "period30d": "30 дней",
    "period90d": "90 дней",
    "periodApply": "Применить",
    "allCompanies": "Все компании",
    "allProjects": "Все проекты",
    "allUsers": "Все пользователи",
    "allModes": "Все типы",
    "empty": "Нет диалогов по фильтру",
    "selectPrompt": "Выберите диалог",
    "selectHint": "Откройте диалог в списке слева, чтобы читать переписку.",
    "open": "Открыть",
    "backToList": "К списку",
    "loadMore": "Показать ещё",
    "pin": "Закрепить",
    "unpin": "Открепить",
    "resizeList": "Ширина списка диалогов",
    "resizePanes": "Граница панелей",
    "closePane": "Закрыть панель",
    "shotTitle": "Шот {{label}}",
    "filters": {
      "title": "Фильтры",
      "active": "Фильтры выбраны",
      "period": "Период",
      "mode": "Тип агента",
      "company": "Компания",
      "project": "Проект",
      "user": "Пользователь",
      "search": "Найти",
      "reset": "Сбросить"
    },
    "modes": {
      "shots_assistant": "Сториборд",
      "characters_assistant": "Герои",
      "locations_assistant": "Локации",
      "props_assistant": "Реквизит",
      "canvas_assistant": "Холст",
      "flow_assistant": "Флоу",
      "skills_assistant": "Скиллы",
      "skills_discussion_assistant": "Скиллы: обсудить",
      "skills_editor_assistant": "Скиллы: редактировать",
      "script_assistant": "Сценарий",
      "projects_assistant": "Проекты",
      "tasks_assistant": "Задачи",
      "scene3d_assistant": "3D-сцены"
    },
    "messages": "Сообщения",
    "mode": "Режим",
    "context": "Контекст",
    "user": "Пользователь",
    "project": "Проект",
    "company": "Компания",
    "lastMessage": "Последнее сообщение",
    "messageCount": "{{count}} сообщ.",
    "roleUser": "Режиссёр",
    "roleAssistant": "Агент",
    "roleTool": "Тул",
    "roleSystem": "Система",
    "toolCalls": "Вызовы тулов",
    "pendingAction": "Ожидает подтверждения",
    "prevPage": "Назад",
    "nextPage": "Ещё",
    "page": "Стр. {{page}}",
    "contextTypes": {
      "project": "Проект",
      "shot": "Шот",
      "character": "Герой",
      "location": "Локация",
      "prop": "Проп",
      "canvas": "Холст",
      "company": "Компания"
    }
  }
}
